import qs from 'querystring'
import {
  ApiRequestService,
  BaseOption,
  ApiType,
  ApiRequestMap,
  ApiRequest,
  defaultApiRequestConfig,
} from './ApiRequestService'

export interface PSMRequestOption extends BaseOption {
  Action: string
}

const defaultPSMRequestOption: PSMRequestOption = {
  ...defaultApiRequestConfig,
  Action: '',
}

/** @description 请求 PSM  */
class PSMApiRequest extends ApiRequest<PSMRequestOption> {
  getAxiosUrl(): string {
    const { query, Action } = this.option

    const defaultUrl = `/api/${Action}/`
    return `${defaultUrl}?${qs.stringify(query)}`
  }
}

export class PSMApiRequestService extends ApiRequestService<PSMRequestOption> {
  constructor(
    apiMap: ApiRequestMap<PSMRequestOption>,
    option: Partial<PSMRequestOption>,
  ) {
    super(apiMap, option, defaultPSMRequestOption)
  }

  getApiInstance(key: string, option: PSMRequestOption): ApiType<PSMRequestOption> {
    return new PSMApiRequest({
      ...option,
      Action: key,
      query: option.query,
    }).instance
  }
}
